import type { ArbitraryTypedObject } from '@portabletext/types';
import { PortableTextBlock } from '@sanity/types';
import { PortableTextWrapper } from './PortableTextWrapper';
import VideoModal from '@/components/VideoModal';
import { Video } from '@/components/LeftTextRightImageAndVideo';
import Image from 'next/image';
import { getSanityImageUrl } from '@/libs/sanity/client';
import { BiExpandAlt } from 'react-icons/bi';
import { useState } from 'react';
import { SlArrowRightCircle } from 'react-icons/sl';
import { BlurInH2 } from '@/components/eldora-ui/blur-in-h2';
import { PortableText } from '@portabletext/react';

type TextImageAndPopupVideoProps = {
  anchor?: string;
  title?: string;
  video?: Video;
  text:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
};

const TextImageAndPopupVideo = ({
  anchor,
  text,
  title,
  video,
}: TextImageAndPopupVideoProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const renderVideoButton = (video: Video) => {
    const isDefaultLabel =
      !video.buttonLabel ||
      video.buttonLabel === 'Enlarge Video' ||
      video.buttonLabel === 'Enlarge Demo';

    return (
      <div
        className={`mt-2 justify-start text-primary gap-x-1 items-center cursor-pointer scroll-mt-[150px] ${isDefaultLabel ? 'flex flex-row' : ''}`}
        onClick={() => setIsModalOpen(true)}
      >
        {video.buttonLabel && (
          <>
            {isDefaultLabel && <BiExpandAlt className="font-bold" />}
            <span>{video.buttonLabel || 'Enlarge Video'}</span>
            {!isDefaultLabel && (
              <SlArrowRightCircle
                className="text-primary mt-1 block"
                size={18}
              />
            )}
          </>
        )}
        {video.buttonLongLabel && (
          <>
            <div className="text-primary">
              <PortableText value={video.buttonLongLabel} />
              <SlArrowRightCircle
                className="text-primary mt-1 block"
                size={18}
              />
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <section id={anchor} className="w-full mt-8">
      <div className="w-full xl:max-w-4xl">
        {title && <BlurInH2>{title}</BlurInH2>}
        {text && <PortableTextWrapper value={text} />}
      </div>
      {video && video.coverImage && (
        <div>
          <div className="mt-8">
            <Image
              src={getSanityImageUrl(video.coverImage)}
              alt="Image"
              className="object-cover"
              loading="lazy"
              width={1000}
              height={2000}
            />
          </div>
          {renderVideoButton(video)}
        </div>
      )}
      {video && (
        <VideoModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          video={video}
        />
      )}
    </section>
  );
};

export default TextImageAndPopupVideo;
